/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { createContext, useContext } from "react";

export interface IFieldSectionContext {
	collapsible: boolean;
	collapsed: boolean;
	toggleCollapsed: () => void;
	root: boolean;
	group?: boolean;
}

export const FieldSectionContext = createContext<IFieldSectionContext>(null);

export function useFieldSectionContext(): IFieldSectionContext {
	return useContext(FieldSectionContext);
}

export const FieldSectionContextProvider: React.FC<Omit<IFieldSectionContext, "root">> = ({
	children,
	collapsible,
	collapsed,
	toggleCollapsed,
	group
}) => {
	const parentFieldSectionCtx = useFieldSectionContext();

	return (
		<FieldSectionContext.Provider
			value={{
				collapsed,
				collapsible,
				toggleCollapsed,
				root: !parentFieldSectionCtx,
				group
			}}
		>
			{children}
		</FieldSectionContext.Provider>
	);
};
